import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Box, Button, Container, Typography } from "@mui/material";
import HaveQuestions from "../components/HaveQuestions";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ backgroundColor: "#F9F9F9" }}>
      <Helmet>
        <title>DAM Journey - Privacy Policy</title>
        <meta
          name="description"
          content="Privacy Policy"
        />
        <meta
          property="keywords"
          content="DAM, DAM Journey, DAM Practice, DAM Consultant, DAM Consulting, DAM Practitioner, DAM Service, DAM Product, DAM Discovery, DAM Implementation, DAM Deployment, Privacy Policy"
        />
      </Helmet>
      <Box>
        {/* Hero Banner Section */}
        <Box
          sx={{
            width: "100%",
            height: "168px",
            background: "linear-gradient(0deg, #2A2177 0%, #0624BE 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            px: "84px",
            py: "60px",
            overflow: "hidden",
            position: "relative",
            "@media (max-width: 780px)": {
              flexDirection: "column",
              textAlign: "center",
              px: "24px",
              py: "48px",
              height: "133px",
            },
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontSize: "2.5rem",
              fontWeight: "Bold",
              color: "#ffffff",
              lineHeight: 1.3,
              mb: 2,
              "@media (max-width: 780px)": {
                fontSize: "2rem",
                fontWeight: "semiBold",
                mb: 1,
              },
            }}
          >
            Privacy Policy
          </Typography>
        </Box>

        {/* Description Section */}
        <Box
          sx={{
            px: "84px",
            py: "48px",
            gap: "16px",
            "@media (max-width: 1200px)": {
              p: "48px",
            },
            "@media (max-width: 780px)": {
              p: "16px",
            },
          }}
        >
          <Box
            sx={{
              flex: 1,
              backgroundColor: "#ffffff",
              borderRadius: "24px",
              p: 4,
              boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.08)",
            }}
          >
            <Typography
              sx={{
                fontSize: "1rem",
                color: "rgba(0, 0, 0, 0.6)",
                mb: 3,
              }}
            >
              DAM Journey LLC is committed to protecting
              your privacy. Our Privacy Policy is designed
              to protect the information that we collect
              from you over the web site while providing
              you with our products and services. We want
              to inform you of our Privacy Policy and to
              ensure that we are taking steps to make sure
              that the information you give us is secure.
            </Typography>

            {/* Header */}
            <Typography
              sx={{
                fontSize: "1.5rem",
                fontWeight: 600,
                color: "#2A2177",
                mb: 1,
                "@media (max-width: 780px)": {
                  fontSize: "1.25rem",
                },
              }}
            >
              Collection of Information
            </Typography>

            <Typography
              sx={{
                fontSize: "1rem",
                color: "rgba(0, 0, 0, 0.6)",
                mb: 3,
              }}
            >
              We require information about our visitors,
              primarily clients and collaborators, in the
              course of obtaining DAM Journey LLC products
              and services through our web site
              (https://damjourney.com/). This information
              may include your name, e-mail address,
              and similar data.
            </Typography>

            {/* Header */}
            <Typography
              sx={{
                fontSize: "1.5rem",
                fontWeight: 600,
                color: "#2A2177",
                mb: 1,
                "@media (max-width: 780px)": {
                  fontSize: "1.25rem",
                },
              }}
            >
              Usage of Collected Information
            </Typography>

            <Typography
              sx={{
                fontSize: "1rem",
                color: "rgba(0, 0, 0, 0.6)",
                mb: 3,
              }}
            >
              If you contact our customer success department
              regarding a support question you have inquired,
              we will have information about you in order to
              serve you. We use your personal information to
              provide you access to specific areas on our web
              site for you to create data required to have the
              best user experience. We do not collect information
              about our clients or visitors from other sources,
              such as public records or bodies or private
              organizations. Also, we do not automatically record
              personal data, or link information logged by other
              means with personal data about specific individuals.
            </Typography>


            {/* Header */}
            <Typography
              sx={{
                fontSize: "1.5rem",
                fontWeight: 600,
                color: "#2A2177",
                mb: 1,
                "@media (max-width: 780px)": {
                  fontSize: "1.25rem",
                },
              }}
            >
              Restricted Access to Collected Information
            </Typography>

            <Typography
              sx={{
                fontSize: "1rem",
                color: "rgba(0, 0, 0, 0.6)",
                mb: 3,
              }}
            >
              We keep your information private and do not share it with
              any entity outside DAM Journey LLC, except as stated below.
              We do not sell or give your information to marketing
              companies. We might use the information to contact you when
              we introduce new products or services, and we might share
              your contact information with the providers of third-party
              software codes that we incorporate into our end-user products.
              You can ask us if we are keeping personal data about you
              and/or list of third-party provider companies by sending
              an e-mail to inquiry@damjourney.com. We will then provide
              you with a readable copy of the requested material. We will
              require proof of your identity before providing such data.
            </Typography>
          </Box>
        </Box>

        {/* Have Questions Section */}
        <HaveQuestions />
      </Box>
    </Box>
  );
};

export default PrivacyPolicy;
